import * as React from 'react';
import { Router, Route, RouteProps, Redirect } from 'react-router';
import { hasValidToken, redirectToLogin } from '../modules/common';

export const PrivateRoute = ({ component: Component, ...rest }: any) => (
    <Route {...rest} render={props => {
        if (hasValidToken()) {
            return <Component {...props} />
        }

        // Missing or expired token: don't render the page (its fetches would fail), go to App Pool login
        redirectToLogin();

        return null;
    }} />
)
